import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import configurations from "config";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useMaterialUIController } from "context";
import CircularProgress from "@mui/material/CircularProgress";
import { CHANGEPASSWORD } from "constants";
import { handleErrors } from "common.js";
import Backdrop from '@mui/material/Backdrop';

function ChangePassword() {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { MyContext } = controller;
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [isLoading, setIsLoading] = useState(false);
  const resetPassword = localStorage.getItem('resetPassword');
  const { register, handleSubmit, watch, formState: { errors }, setValue, setError } = useForm();

  useEffect(() => {
    if (resetPassword && resetPassword == CHANGEPASSWORD.RESETPASSWORD_SET)
      toast.success(t('setNewPasswordByVendor'))
  }, []);

  const onSubmit = async (data) => {
    setIsLoading(true);
    axios.post(baseUrl + '/vendor/changePassword', data, {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
    }).then((response) => {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          localStorage.setItem("resetPassword", CHANGEPASSWORD.RESETPASSWORD_UNSET)
          toast.success(t(message))
        }
        else {
          if (message != '')
            toast.error(t(message))
          if (response && response.data && response.data.errors) {
            const errorData = response.data.errors;
            errorData.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: t(error.errors[0])
              });
            });
          }
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(error => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  return (
    <DashboardLayout>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
      <DashboardNavbar pageTitle={t('changePassword')} />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox pt={3}>
                <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                  <MDBox px={3}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('currentPassword')}
                          <MDTypography component="span" variant="body2" fontWeight="bold" color="error" >*</MDTypography>
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          type="password"
                          name="currentPassword"
                          InputProps={{
                            classes: { root: "inputBoxStyle" },
                          }}
                          {...register("currentPassword", {
                            required: {
                              value: true,
                              message: t('currentPasswordRequired')
                            },
                            minLength: {
                              value: MyContext.minPasswordLength,
                              message: t('passwordMinLength', { minPasswordLength: MyContext.minPasswordLength })
                            }
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />
                        {errors.currentPassword && (<span className="errorMsg floatRight">{errors.currentPassword.message}</span>)}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('newPassword')}
                          <MDTypography component="span" variant="body2" fontWeight="bold" color="error" >*</MDTypography>
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          type="password"
                          name="newPassword"
                          InputProps={{
                            classes: { root: "inputBoxStyle" },
                          }}
                          {...register("newPassword", {
                            required: {
                              value: true,
                              message: t('newPasswordRequired')
                            },
                            minLength: {
                              value: MyContext.minPasswordLength,
                              message: t('passwordMinLength', { minPasswordLength: MyContext.minPasswordLength })
                            }
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />
                        {errors.newPassword && (<span className="errorMsg floatRight">{errors.newPassword.message}</span>)}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('confirmPassword')}
                          <MDTypography component="span" variant="body2" fontWeight="bold" color="error" >*</MDTypography>
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          type="password"
                          name="confirmPassword"
                          InputProps={{
                            classes: { root: "inputBoxStyle" },
                          }}
                          {...register("confirmPassword", {
                            required: {
                              value: true,
                              message: t('confirmPasswordRequired')
                            },
                            minLength: {
                              value: MyContext.minPasswordLength,
                              message: t('passwordMinLength', { minPasswordLength: MyContext.minPasswordLength })
                            },
                            validate: (value) => {
                              if (watch('newPassword') != value) {
                                return t('passwordMismatch');
                              }
                            },
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />
                        {errors.confirmPassword && (<span className="errorMsg floatRight">{errors.confirmPassword.message}</span>)}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}></Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDButton type="submit" variant="gradient" color="info" disableRipple>{t('submit')}</MDButton>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ChangePassword;
